import { FunctionComponent } from "react";
import styles from "./styles.module.css";

interface dadoProps {
  chave: string;
  valor: string;
  quebraDeLinha?: boolean;
}

const LinhaDado: FunctionComponent<dadoProps> = ({
  chave,
  valor,
  quebraDeLinha,
}) => {
  return (
    <>
      <span className={styles.linhaDado}>
        <strong>{chave}:</strong>
        {quebraDeLinha && <br />} {valor}
      </span>
    </>
  );
};

export default LinhaDado;
